import { SubmissionError } from 'redux-form'
import store from 'store'

export default function handleFormErrors(res) {
  if (res.status === 404) {
    return { status: 404, response: null }
  }
  if (res.status != 200) {
    if (res.status == 500) {
      return store.dispatch({ type: 'SHOW_ERROR', payload: 'Something went wrong' })
    }

    if (res.response) {
      const v = res.response.validationErrors
      if (v) {
        const errs = {}
        for (let f in v) {
          errs[f] = v[f][0]
        }
        throw new SubmissionError(Object.assign({ __status: res.status }, errs))
      } else {
        throw new SubmissionError(Object.assign({ __status: res.status }, res.response))
      }
    }

   // return store.dispatch({ type: 'SHOW_ERROR', payload: 'Something went wrong' })
  }
  return res
}



// WEBPACK FOOTER //
// ./src/utils/handleFormErrors.js